import styled from "styled-components";

export const Main = styled.main`
    width: 100%;
    height: 100vmin;
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 400px){
        height: 100vh;
    }
`;
